import React from "react";
import { string } from "prop-types";

export const SEOText = (props) => {
  const { title, text } = props;
  return (
    <div className="seo-wrapper">
      <div className="seo-container">
        <p className="seo-title">{title}</p>
        <p className="seo-text" dangerouslySetInnerHTML={{ __html: text }}></p>
      </div>
      <style jsx>{`
        .seo-wrapper {
          display: flex;
          justify-content: center;
          background-color: var(--color-white-soft);
        }
        .seo-container {
          max-width: 940px;
          width: 100%;
          padding: 16px;
        }
        .seo-title {
          font-size: 18px;
          font-weight: bold;
        }
        .seo-text {
          font-size: 10.5px;
        }
        @media only screen and (max-width: 600px) {
          .seo-title {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

SEOText.propTypes = {
  title: string,
  text: string
};
